import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseNestedProductCategoryDto } from '../types/dtos';
import { formatDate } from 'utils/date-helpers';
import { store } from 'store/index';

export type NestedProductCategoriesQueryParams = BaseQueryParams & {
    website_id?: string;
};

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.query<PaginatedResponse<ResponseNestedProductCategoryDto>, NestedProductCategoriesQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const websiteId = store.getState().workspace.websiteId;
            const params: NestedProductCategoriesQueryParams = { ..._arg, website_id: websiteId };
            const nestedProductCategoriesResponse = await fetchWithBQ(
                constructQueryParams(APP_ENDPOINTS.NESTED_PRODUCT_CATEGORIES, params),
            );

            if (nestedProductCategoriesResponse.error) {
                return { error: nestedProductCategoriesResponse.error };
            }

            const nestedProductCategories =
                nestedProductCategoriesResponse.data as PaginatedResponse<ResponseNestedProductCategoryDto>;

            nestedProductCategories.content = nestedProductCategories.content.map((nestedProductCategory) => {
                const createdAt = formatDate(nestedProductCategory.createdAt);

                let maxSelection: string;
                if (nestedProductCategory.isMultiSelect === false) {
                    maxSelection = '1';
                } else if (
                    nestedProductCategory.maxSelection === null &&
                    nestedProductCategory.isMultiSelect === true
                ) {
                    maxSelection = 'UNLIMITED';
                } else if (nestedProductCategory.maxSelection !== null) {
                    maxSelection = nestedProductCategory.maxSelection.toString();
                } else {
                    maxSelection = '';
                }

                return {
                    ...nestedProductCategory,
                    createdAt,
                    maxSelection,
                };
            });
            return {
                data: nestedProductCategories,
            };
        },
        providesTags: [{ type: 'nested-product-categories', id: 'GET' }],
    });
